// extracted by mini-css-extract-plugin
export default {"hidden":"Login__hidden--hddPf","container":"Login__container--NBB1q","wrapper":"Login__wrapper--e_G2R","personIcon":"Login__personIcon--JefqO"};